const stringToPickerObj = (str) => {
    let obj = {};
    let options = str.split('|');
    options.forEach(ele => {
        let arr = ele.split(":");
        let id = arr[0] + '';
        obj[id] = arr[1];
    });
    return obj;
}

const arrayToStr = (content, value) => {
    let data = [];
    let options = content.split('|');
    options.forEach(ele => {
        let arr = ele.split(":");
        if (Array.isArray(value)) {
            value.forEach(e => {
                if (e == arr[0]) {
                    data.push(arr[1]);
                }
            })
        } else {
            if (value == arr[0]) {
                data.push(arr[1]);
            }
        }
    });

    return data.join(",");
}

const getRuleTag = (addons, rule) => {
    let field = rule.field;
    let type = rule.type;
    let value = addons[field];
    if (!['select', 'checkbox', 'radio'].includes(type)) return value;
    if (["select", "radio"].includes(type)) {
        let obj;
        obj = stringToPickerObj(rule.content);
        return obj[value] ? obj[value] : '-';
    }

    if (type == "checkbox") {
        return arrayToStr(rule.content, value)
    }
}

const getDemandStatusTag = (demand) => {
    let title = [];
    if (demand.item_check_status > 0) {
                
    }

    // 审核
    if (demand.item_check_status == 2) {

    }

    return title.join(",");
}

export default {
    stringToPickerObj,
    getRuleTag,
    getDemandStatusTag
}